export const getAllFolders = async (payload, authToken) => {
  // Visibility-> active,disabled,"all"
  const { pageNo, limit, isSorted, sortBy, searchText, visibility } = payload;
  const url = `${
    process.env.REACT_APP_BASE_URL
  }/getAllFolders?pageNo=${pageNo}&limit=${limit}&visibility=${visibility}${
    searchText ? "&searchText=" + searchText : ""
  }${sortBy ? "&sortBy=" + sortBy : ""}${
    isSorted ? "&isSorted=" + isSorted : ""
  }`;

  try {
    return await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: authToken,
      },
    })
      .then((res) => res.json())
      .catch((error) => error.message);
  } catch (error) {
    console.error("Coming from FAQ services : getAllFolders() ", error.message);
    if (error.message === "Network Error") {
      return error.message;
    }
  }
};

export const addOrUpdateFolder = async (payload, authToken) => {
  try {
    return await fetch(`${process.env.REACT_APP_BASE_URL}/updateFolder`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: authToken,
      },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .catch((error) => error.message);
  } catch (error) {
    console.error(
      "Coming from Folder services : addOrUpdateFolder()",
      error.message
    );
    if (error.message === "Network Error") {
      return error.message;
    }
  }
};

export const updateFoldersVisibility = async (payload, authToken) => {
  try {
    return await fetch(
      `${process.env.REACT_APP_BASE_URL}/updateFoldersVisibility`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: authToken,
        },
        body: JSON.stringify(payload),
      }
    )
      .then((res) => res.json())
      .catch((error) => error.message);
  } catch (error) {
    console.error(
      "Coming from Folder services : updateFoldersVisibility()",
      error.message
    );
    if (error.message === "Network Error") {
      return error.message;
    }
  }
};

export const deleteFolders = async (payload, authToken) => {
  try {
    return await fetch(`${process.env.REACT_APP_BASE_URL}/deleteFolders`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: authToken,
      },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .catch((error) => error.message);
  } catch (error) {
    console.error(
      "Coming from Folder services : deleteFolders()",
      error.message
    );
    if (error.message === "Network Error") {
      return error.message;
    }
  }
};

export const moveToFolders = async (payload, authToken) => {
  try {
    return await fetch(`${process.env.REACT_APP_BASE_URL}/moveToFolders`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: authToken,
      },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .catch((error) => error.message);
  } catch (error) {
    console.error(
      "Coming from Folder services : moveToFolders()",
      error.message
    );
    if (error.message === "Network Error") {
      return error.message;
    }
  }
};
